import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RightArrow } from "../../assets/images/back-arrow.svg";
import { ReactComponent as RightArrowWhite } from "../../assets/images/back-arrow-white.svg";

function BackArrow({ isDark }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={classnames("text-left arrow-back")} onClick={handleBack} role="presentation">
      {isDark ? (
        <RightArrow className={classnames("icon breadcrumb-icon my-auto", { black: isDark })} />
      ) : (
        <RightArrowWhite
          className={classnames("icon breadcrumb-icon my-auto", { white: !isDark })}
        />
      )}
      <span
        className={classnames(
          "d-none d-lg-block label medium icon breadcrumb-text",
          { dark: isDark },
          { light: !isDark },
        )}
      >
        Back
      </span>
    </div>
  );
}

BackArrow.defaultProps = {
  isDark: false,
};

BackArrow.propTypes = {
  isDark: PropTypes.bool,
};

export default BackArrow;
